import React from 'react';

const Search = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.99967 13.1673C10.1293 13.1673 12.6663 10.6303 12.6663 7.50065C12.6663 4.37105 10.1293 1.83398 6.99967 1.83398C3.87007 1.83398 1.33301 4.37105 1.33301 7.50065C1.33301 10.6303 3.87007 13.1673 6.99967 13.1673Z"
        stroke={props?.stroke || '#1B1F4D'}
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M11.0742 11.5742L13.9027 14.4027"
        stroke={props?.stroke || '#1B1F4D'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Search;
